import { useEffect } from "react";
import MuiSwitch from "@mui/material/Switch";
import type { SwitchProps as MuiSwitchProps } from "@mui/material/Switch";
import FormControl from "@mui/material/FormControl";
import FormControlLabel from "@mui/material/FormControlLabel";
import { get } from "lodash";
import { useFormikContext } from "formik";
import { FormHelperText } from "@mui/material";
import type { ReactNode } from "react";

import { useFormContext } from "@/hooks/useFormContext";
import { FormSkeleton } from "../../skeleton";

type FormValues = Record<string, unknown>;

export interface SwitchProps extends Omit<MuiSwitchProps, "error"> {
  name: string;
  label?: ReactNode;
  loading?: boolean;
  error?: string;
}

export function Switch({ name, label, onChange, checked, loading, sx, error }: SwitchProps) {
  const formik = useFormikContext<FormValues>();
  const formContext = useFormContext();

  useEffect(() => {
    formik.setFieldError(name, error);
  }, [error]);

  return (
    <FormSkeleton loading={loading ?? formContext?.loading}>
      <FormControl sx={{ width: "100%" }} error={Boolean(get(formik.errors, name))}>
        <FormControlLabel
          label={label}
          control={
            <MuiSwitch
              name={name}
              sx={sx}
              checked={(checked ?? get(formik.values, name, null)) as boolean}
              onChange={onChange ?? formik.handleChange}
            />
          }
        />
        {Boolean(get(formik.errors, name)) && (
          <FormHelperText>{get(formik.errors, name) as ReactNode}</FormHelperText>
        )}
      </FormControl>
    </FormSkeleton>
  );
}
